import { Info } from '@phosphor-icons/react';
import { DarkPopup } from '@elements/Popup';
import type { ITableHeaderToolTipProps } from 'types/common/table';

/**
 * A label with an info icon whose hover or focus shows `helpText`. Lives on
 * its own so that importing it (as elements/Common does) does not pull in
 * the whole AppTable and its legacy table, pagination and buttons.
 */
export function TableHeaderToolTip({
  label = '',
  helpText = '',
  helpPosition = 'top center',
  contentWidth,
  color,
  noInfoRightPadding: _noInfoRightPadding,
  wrapperClass: _wrapperClass,
  popupProps: _popupProps,
  ...rest
}: ITableHeaderToolTipProps) {
  return (
    <>
      {label}
      {helpText && (
        <DarkPopup
          contentWidth={contentWidth}
          position={helpPosition}
          trigger={
            <Info
              size={14}
              color={color || '#878787'}
              className="sk:mb-[-3px] sk:ml-[5px] sk:cursor-pointer"
            />
          }
          {...rest}
        >
          {helpText}
        </DarkPopup>
      )}
    </>
  );
}
